@if (data.from_tennis_match) {
  <div class="match-chat-header">
    @if (!is_livestream) {
      <h2 class="chat-title">{{ handleChatTitle() }}</h2>
    }
    <div class="spoiler-toggle-mat">
      <mat-slide-toggle [checked]="spoiler_free_toggle" (change)="spoiler_free_toggle = $event.checked" color="primary" aria-label="Toggle spoiler-free mode">
        {{ appStringsService.getAppString('tennischat.spoiler') }}
      </mat-slide-toggle>
    </div>
  </div>
}

@if (data.from_tennis_match && !spoiler_free_toggle) {
  <app-tennis-match
    [match_data]="data.match_data"
    [round]="data.match_data.round"
    style="width: 70%; margin: 10px auto"
    [from_match_details]="true"
    [attr.data-match-id]="data.match_data.id"
  ></app-tennis-match>
}

@if ((sponsor | keyvalue)?.length) {
  <div class="match-sponsor">
    @if (video_ad_sponsor) {
      <app-rotating-sponsors [video_ad_sponsor]="video_ad_sponsor" [sponsor_id]="sponsor.id" [default_aspect_ratio]="'9:1'"></app-rotating-sponsors>
    } @else {
      <app-rotating-sponsors [sponsor_id]="sponsor.id" [default_aspect_ratio]="'9:1'"></app-rotating-sponsors>
    }
  </div>
}

<!-- <div class="chat-welcome" *ngIf="data.from_tennis_match || show_welcome">
<app-app-string [key_name]="'tennischat.welcome'"></app-app-string>
</div> -->

@if (ssr.isClientSide) {
  @if (loaded()) {
    <lib-bleachr-chat
      class="chat"
      [host_url]="hostUrl"
      [subject_id]="subjectID"
      [chat_type]="subjectType"
      [subject_name]="subjectName"
      [fingerprint]="fingerprint"
      [token]="chatToken"
      [app_string_url]="appStringUrl"
      [spoiler_free_mode]="spoiler_free_toggle"
      [chatbox_height]="chatbox_height"
      [chatbox_width]="chatbox_width"
      [elixir_url]="elixirUrl"
      [type_limits]="chat_type_limits"
      [sponsor_id]="sponsor_key"
      chatbox_height="51vh"
    ></lib-bleachr-chat>
  }
}

@if (is_livestream) {
  <h2 class="chat-title" style="margin: 0">{{ handleChatTitle() }}</h2>
}
@if (loaded()) {
  <div class="chat-container" [ngClass]="{ livestream: is_livestream }" id="chat-area" [ngClass]="subject_type === 'tennis_schedule' ? 'schedule-container' : ''">
    <div class="chat-frame" [ngClass]="subject_type === 'tennis_schedule' ? 'schedule-frame' : ''">
    </div>
  </div>
}
